import React, { useRef } from 'react'
import {useDrag, useDrop} from 'react-dnd'
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import InputBase from '@mui/material/InputBase'
import fieldTypes from './field-content'
import './field.styl'

function setName (context, field, name) {
  const data = context.newPlan
  if (data.items) {
    const items = data.items.map(item => item.id === field ? {...item, content: {...item.content, name}} : item)
    const newPlan = {...data, items}
    context.setState({newPlan})
  }
}

export default function Field (props) {
  const { id, name, index, moveField, className, deleteField, context } = props
  const ref = useRef(null)
  const [, drop] = useDrop({
    accept: 'FIELD',
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveField(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    },
  })
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'FIELD', id, index },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })
  const opacity = isDragging ? 0 : 1
  drag(drop(ref))
  const sections = props.sections
    .map((props, contentId) => ({props, Element: fieldTypes[props.type], contentId}))
    .filter(section => section.Element)
    .map(({Element, props, contentId}, index) => (<Element key={index} {...props} id={id} contentId={contentId} context={context} />))

  return (
    <div id={id} style={{opacity}} className={`${className} field`}>
      <div ref={ref} className="title">
        <div className="sorter">
          <div className="dots" />
        </div>
        <div className="name">
          <InputBase
            id={`${id}-name`}
            value={name}
            readOnly={props.className != 'annotations'}
            onChange={e => setName(context, id, e.target.value)}
            margin="dense"
          />
        </div>
        <div className="delete" onClick={deleteField}>
          <FontAwesomeIcon icon={faTimesCircle} />
        </div>
      </div>
      <div className="content">
        {sections}
      </div>
    </div>
  )
}
